import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../data/mock';

const COUNTER_DURATION_MS = 2000;

const Counter = ({ target, suffix, decimal }) => {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const animate = (now) => {
              const progress = Math.min((now - start) / COUNTER_DURATION_MS, 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              setValue(target * eased);
              if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [target]);

  const display = decimal
    ? value.toFixed(1).replace('.', ',')
    : Math.floor(value).toLocaleString('pt-BR');

  return (
    <span ref={ref} className="text-5xl md:text-6xl font-bold text-[#D4AF37] tabular-nums">
      {display}
      {decimal ? '' : suffix}
    </span>
  );
};

const Stats = () => {
  return (
    <section className="py-20 bg-transparent" data-testid="stats-section">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {stats.map((stat) => (
            <div
              key={stat.id}
              data-testid={`stat-${stat.id}`}
              className="text-center p-6 rounded-sm bg-black/60 backdrop-blur-md border border-[#D4AF37]/20 hover:border-[#D4AF37]/60 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="mb-3">
                <Counter target={stat.value} suffix={stat.suffix} decimal={stat.decimal} />
              </div>
              <p className="text-gray-400 text-sm md:text-base uppercase tracking-wider">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
